<template>
    <div>
        <h2 class="pause--heading" v-text="$t('CANCEL_STEP_HEADING')"></h2>
        <p class="feedback--question" v-text="$t('CANCEL_DELIVERIES_MISSING')"/>
        <image-carousel v-if="hasMissedArrangements" :images="missedArrangements"/>
        <h2 class="pause--heading" v-text="$t('CANCEL_STEP_SUB_HEADING')"></h2>
        <p class="feedback--question" v-text="cancelCopy"/>
        <button @click.prevent="nextStep" class="btn btn--primary btn--full-width confirm--button " v-text="$t('YES_CANCEL_NEXT')"></button>
        <button v-text="$t('NO_THANKS_RESUME_MY_DELIVERIES')"
                @click.prevent="goBackToAddresses" class="btn btn--secondary-black btn--full-width restart-date--reject mt-4">
        </button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import ImageCarousel from '@/components/partials/account/shop/product-details/ImageCarousel';

let subscriptionService = new SubscriptionService();

export default {
    components: { ImageCarousel },
    name: 'FlowersMissingStep',
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
        },
        stage: {
            type: String,
        },
        altText: {
            required: false,
            type: String,
            default: 'Product image',
        },
    },
    data() {
        return {
            feedback: null,
            stageId: 'flowers-missing',
            errorHandler: new ErrorResponseHandler(),
            window: {
                width: 0,
                mobileBreakpoint: 768,
            },
        };
    },
    computed: {
        ...mapGetters({
            missedArrangements: 'cms/getMissedArrangements',
            subscription: 'subscription/getActiveSubscription',
            activeSubscriptions: 'subscription/getActiveSubscriptions',
        }),
        isMobile() {
            return this.window.width < this.window.mobileBreakpoint;
        },
        hasMissedArrangements() {
            return this.missedArrangements && this.missedArrangements.length !== 0;
        },
        cancelCopy() {
            return this.activeSubscriptions && this.activeSubscriptions.length === 1 ? this.$t('CANCEL_DELIVERIES_MISSING_FLOWERS_COUPON') : this.$t('CANCEL_DELIVERIES_MISSING_FLOWERS');
        },
        updatedSteps() {
            const currentStepIndex = this.pauseSurveyAnswer.nextSteps.indexOf(this.stageId);
            return this.pauseSurveyAnswer.nextSteps.slice(currentStepIndex + 1);
        },
    },
    mounted() {
        this.fetchMissedArrangements();
    },
    methods: {
        ...mapActions({
            fetchMissedArrangements: 'cms/fetchMissedArrangements',
        }),
        setCurrentSlide() {
            this.currentSlide = this.carousel.scrollLeft / this.carousel.offsetWidth;
        },
        goToSlide(slideIndex) {
            const width = this.carousel.offsetWidth;
            this.carousel.scrollTo(width * slideIndex, 0);
        },
        goBackToAddresses() {
            return this.$router.push({ name: 'account.delivery-addresses' });
        },
        nextStep() {
            this.$scrollTo('.main');
            this.$emit('input', this.updatedSteps);
        },
    },
};
</script>

<style lang="scss" scoped>

.feedback--question {
    margin: 24px 0 16px;
    text-align: left;
}

.feedback--textarea {
    font-size: 18px;
    line-height: 22px;
    padding: 8px 12px;
    height: 100px;
}

.confirm--button {
    margin: 28px 0 0;
    background: #262323;
    height: 40px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
}

.restart-date--reject {
    margin: 10px 0 0px;
    height: 40px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
}

</style>
